export enum TranslationsKeys {
  // Globals
  TERMS = 'terms',
  COMMON = 'common',
  INPUTS = 'inputs',
  STUDY_PLAN_ENROLLMENT_STATUS = 'study-plan-enrollment-status',
  // Layouts
  AUTHORIZED_LAYOUT = 'layouts/authorized',
  // Olds
  OLD_TRANSLATIONS = 'translation',
  // academic-offer
  ACADEMIC_OFFER_COURSES_LIST = 'academic-offer/courses/list',
  ACADEMIC_OFFER_COURSES_UPDATE = 'academic-offer/courses/update',
  ACADEMIC_OFFER_ADMISSION_PROCESSES = 'academic-offer/admission-processes',
  COURSE_GROUPS = 'courseGroups/index',
  // admission-and-enrollments
  // configuration
  CONFIGURATION_ACADEMIC = 'configuration/academic',
  CONFIGURATION_FINANTIAL = 'configuration/finantial',
  CONFIGURATION_ACADEMIC_OFFER = 'configuration/academic-offer',
  CONFIGURATION_FIANANTIAL_OTHERS = 'configuration/finantial-others',
  CONFIGURATION_GRADING_STRUCTURE = 'configuration/grading-structure',
  CONFIGURATION_INSTITUTIONS = 'configuration/institutions',
  CONFIGURATION_ADDITIONAL_CHARGES = 'configuration/additional-charges',
  CONFIGURATION_TABS = 'configuration/tabs',
  CONFIGURATION_HOMOLOGATION = 'configuration/homologation',
  // teacher-management
  TEACHER_MANAGMENT_TEACHER_ACTIVATION = 'teacher-management/teacher-activation',
  TEACHER_MANAGMENT_TEACHER_FILE = 'teacher-management/teacher-file',
  TEACHER_MANAGMENT_TEACHER_FILE_LIST = 'teacher-management/teacher-file/list',
  TEACHER_MANAGMENT_TEACHER_FILE_ADDITIONAL_DOCUMENTATION = 'teacher-management/teacher-file/additional-documentation',
  TEACHER_MANAGMENT_TEACHER_FILE_EDUCATIONAL_BACKGROUND = 'teacher-management/teacher-file/educational-background',
  TEACHER_MANAGMENT_TEACHER_FILE_EMPLOYMENT_BACKGROUND = 'teacher-management/teacher-file/employment-background',
  TEACHER_MANAGMENT_TEACHER_FILE_HIRING_INFORMATION = 'teacher-management/teacher-file/hiring-information',
  TEACHER_MANAGMENT_TEACHER_FILE_PERSONAL_BACKGROUND = 'teacher-management/teacher-file/personal-background',
  TEACHER_MANAGMENT_TEACHER_FILE_PERSONAL_BACKGROUND_REFORMADA = 'teacher-management/teacher-file/personal-background-reformada',
  TEACHER_MANAGMENT_TEACHER_FILE_ASSIGNED_STUDENTS = 'teacher-management/teacher-file/assigned-student',
  TEACHER_MANAGMENT_TEACHER_ATTENDANCES = 'teacher-management/teacher-attendances',
  // tuition-continuity
  TC_DISCOUNT_MANAGEMENT = 'tuition-continuity/discount-allocation-management',
  CREDIT_LIQUIDATION = 'tuition-continuity/credit-liquidation',
  CREDIT_LIQUIDATION_INITIAL = 'admission/credit-liquidation',
  // tutor-management
  TUTOR_MANAGEMENT_TUTOR_ASSIGNMENT = 'tutor-management/tutor-assignment',
  // management-tools
  MANAGEMENT_TOOLS_REPORTS_TABS = 'management-tools/reports/tabs',
  MANAGEMENT_TOOLS_REPORTS_ASYNC = 'management-tools/reports/reports-async',
  MANAGEMENT_TOOLS_SURVEY = 'management-tools/surveys/survey',
  MANAGEMENT_TOOLS_SURVEY_RESULTS = 'management-tools/surveys/survey-results',
  MANAGEMENT_TOOLS_SURVEY_EVALUATION_SCALES = 'management-tools/surveys/evaluation-scales',
  MANAGEMENT_TOOLS_ANNOUNCEMENTS_ADMIN_LIST = 'management-tools/announcements/admin-list',
  MANAGEMENT_TOOLS_ANNOUNCEMENTS_LIST = 'management-tools/announcements/list',
  MANAGEMENT_TOOLS_ANNOUNCEMENTS_MODAL = 'management-tools/announcements/modal',
  MANAGEMENT_TOOLS_PERFORMANCE_ANALYSIS = 'management-tools/performance-analysis/performance-analysis-list',
  MANAGEMENT_TOOLS_CLASSROOMS = 'management-tools/classrooms/classrooms-list',
  MANAGEMENT_TOOLS_CLASSROOMS_FORM = 'management-tools/classrooms/form',
  MANAGEMENT_TOOLS_CLASSROOM_CALENDAR = 'management-tools/classrooms/classroom-calendar',
  // student-management
  STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST = 'student-management/student-removal-request/index',
  STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_STUDENTS = 'student-management/student-removal-request/students',
  STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_HISTORY = 'student-management/student-removal-request/history',
  STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_VIEW = 'student-management/student-removal-request/view',
  STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_MANAGEMENT = 'student-management/student-removal-request-management/index',
  STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_MANAGEMENT_PENDING = 'student-management/student-removal-request-management/requests-pending',
  STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_MANAGEMENT_DETAILS = 'student-management/student-removal-request-management/details',
  STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_MANAGEMENT_RESOLVED = 'student-management/student-removal-request-management/requests-resolved',
  // student-alerts
  STUDENT_ALERTS = 'student-alerts/main',
  STUDENT_ALERTS_SUMMARY = 'student-alerts/summary',
  STUDENT_ALERTS_DETAILS = 'student-alerts/details',
  STUDENT_ALERTS_OBSERVATIONS = 'student-alerts/observations',
  STUDENT_RISK_EVALUATION_SESSIONS_LIST = 'student-risk-evaluation-sessions/list',
  STUDENT_RISK_EVALUATION_SESSIONS_FORM = 'student-risk-evaluation-sessions/form',
  STUDENT_RISK_EVALUATION_SESSIONS_STUDENTS = 'student-risk-evaluation-sessions/students',
  STUDENT_RISK_HISTORY = 'student-risk-history/student-risk-history',
  // payment-hub
  PAYMENT_HUB_DEBTS = 'payment-hub/debts',
  PAYMENT_HUB_NON_SALENOTES = 'payment-hub/non-salenotes',
  // Student File
  STUDENT_FILE_OBSERVATIONS = 'student-file/observations',
  // student-warnings
  STUDENT_WARNINGS_STUDENT_HISTORY = 'student-warnings/student-history',
  STUDENT_WARNINGS_STUDENT_SESSION_DETAIL = 'student-warnings/student-session-detail',
  // student-warnings-observations
  STUDENT_WARNINGS_STUDENT_OBSERVATIONS = 'student-warnings/student-observations',

  // admission-management-admission-call
  ADMISSION_MANAGEMENT_ADMISSION_CALL = 'admission-call/admission-call',
  // homologation
  HOMOLOGATION = 'homologation/homologation-requests',
  HOMOLOGATION_DETAIL = 'homologation/homologation-requests-detail',
  HOMOLOGATION_AUTHORIZATION = 'homologation/homologation-authorization',
  HOMOLOGATION_AUTHORIZATION_DETAIL = 'homologation/homologation-authorization-detail',
  // continuous-education
  CONTINUOUS_EDUCATION_STUDY_PLANS = 'continuous-education/study-plans',
  CONTINUOUS_EDUCATION_SECTIONS = 'continuous-education/sections',
}

export const TranslatonsArray = Object.values(TranslationsKeys);
